import React from "react";

export const formatNumber = (value) => {
  if (value === null || value === undefined) return "-";
  return Number(value).toLocaleString("tr-TR");
};

export const formatRate = (part, whole) => {
  if (!whole || whole === 0) return "-";
  return ((part / whole) * 100).toFixed(1) + "%";
};

export const StatCard = ({ label, value, sub, color = "#1976d2" }) => (
  <div
    style={{
      flex: "1 1 160px",
      minWidth: "160px",
      background: "#fff",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      padding: "16px",
      borderTop: `3px solid ${color}`,
    }}
  >
    <div style={{ fontSize: "13px", color: "#666", marginBottom: "6px" }}>{label}</div>
    <div style={{ fontSize: "26px", fontWeight: "bold", color: "#222", lineHeight: 1.1 }}>
      {typeof value === "number" ? formatNumber(value) : value ?? "-"}
    </div>
    {sub && <div style={{ fontSize: "12px", color: "#999", marginTop: "6px" }}>{sub}</div>}
  </div>
);

export const SectionCard = ({ title, actions, children }) => (
  <div
    style={{
      background: "#fff",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      padding: "20px",
      marginBottom: "20px",
    }}
  >
    {(title || actions) && (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "10px",
          marginBottom: "15px",
        }}
      >
        {title && <h3 style={{ margin: 0, fontSize: "16px" }}>{title}</h3>}
        {actions && <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>{actions}</div>}
      </div>
    )}
    {children}
  </div>
);

export const RefreshButton = ({ onClick, isLoading, label = "Yenile" }) => (
  <button
    onClick={onClick}
    disabled={isLoading}
    style={{
      background: "#fff",
      color: "#1976d2",
      border: "1px solid #1976d2",
      padding: "6px 14px",
      borderRadius: "4px",
      cursor: isLoading ? "not-allowed" : "pointer",
      fontSize: "13px",
      opacity: isLoading ? 0.6 : 1,
    }}
  >
    {isLoading ? "Yükleniyor..." : label}
  </button>
);

export const Badge = ({ children, color = "#f5f5f5", textColor = "#333" }) => (
  <span
    style={{
      padding: "3px 8px",
      borderRadius: "4px",
      fontSize: "12px",
      background: color,
      color: textColor,
      whiteSpace: "nowrap",
    }}
  >
    {children}
  </span>
);

const thStyle = (align) => ({
  padding: "10px",
  textAlign: align || "left",
  borderBottom: "2px solid #ddd",
  whiteSpace: "nowrap",
  position: "sticky",
  top: 0,
  background: "#f5f5f5",
});

const tdStyle = (align) => ({
  padding: "8px 10px",
  textAlign: align || "left",
  borderBottom: "1px solid #eee",
});

/**
 * columns: [{ key, label, align, render }]
 */
export const SimpleTable = ({ columns, rows, emptyText = "Kayıt yok.", maxHeight = "500px", rowKey }) => {
  if (!rows || rows.length === 0) {
    return <p style={{ color: "#999", margin: 0 }}>{emptyText}</p>;
  }

  return (
    <div style={{ overflowX: "auto", overflowY: "auto", maxHeight }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={thStyle(col.align)}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={rowKey ? rowKey(row, idx) : idx}>
              {columns.map((col) => (
                <td key={col.key} style={tdStyle(col.align)}>
                  {col.render ? col.render(row, idx) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const RateBar = ({ rate }) => {
  const numeric = typeof rate === "string" ? parseFloat(rate) : rate;
  const safe = isNaN(numeric) ? 0 : Math.min(Math.max(numeric, 0), 100);
  const color = safe >= 66 ? "#2e7d32" : safe >= 33 ? "#f9a825" : "#c62828";
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px", minWidth: "120px" }}>
      <div style={{ flex: 1, height: "6px", background: "#eee", borderRadius: "3px", overflow: "hidden" }}>
        <div style={{ width: `${safe}%`, height: "100%", background: color }} />
      </div>
      <span style={{ fontSize: "12px", color: "#555", minWidth: "44px", textAlign: "right" }}>
        {isNaN(numeric) ? "-" : safe.toFixed(1) + "%"}
      </span>
    </div>
  );
};

export const ErrorMessage = ({ message }) =>
  message ? (
    <div
      style={{
        padding: "10px 14px",
        background: "#ffebee",
        border: "1px solid #ef9a9a",
        borderRadius: "6px",
        color: "#c62828",
        fontSize: "13px",
        marginBottom: "15px",
      }}
    >
      {message}
    </div>
  ) : null;
